import React, { memo } from 'react';
import { Waypoint } from 'react-waypoint';
import { Icon } from 'semantic-ui-react';
import {
  func, shape, bool, arrayOf,
} from 'prop-types';
import { hasItemInList } from 'Helpers/utils';

import DoctorItem from './DoctorItem';
import styles from './DoctorList.less';

const DoctorList = (props) => {
  const {
    list,
    selectedItems,
    onClickItem,
    loadDoctor,
    showLoadMore,
    loading,
  } = props;

  const loadMore = () => {
    if (!loading) {
      loadDoctor();
    }
  };

  return (
    <div className={styles.container}>
      {
        list.map(i => (
          <DoctorItem
            item={i}
            key={i.id}
            onClickItem={onClickItem}
            isActive={hasItemInList(selectedItems, i, 'id')}
          />
        ))
      }
      {
        showLoadMore
        && (
          <Waypoint onEnter={loadMore}>
            <div style={{ textAlign: 'center' }}>
              <Icon name="spinner" loading size="large" />
            </div>
          </Waypoint>
        )
      }
    </div>
  );
};


DoctorList.propTypes = {
  loading: bool.isRequired,
  loadDoctor: func.isRequired,
  onClickItem: func.isRequired,
  showLoadMore: bool.isRequired,
  selectedItems: arrayOf(shape({})),
  list: arrayOf(shape({})).isRequired,
};

DoctorList.defaultProps = {
  selectedItems: [],
};

export default memo(DoctorList);
